import React, { useState } from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import models_icon from '../../assets/icons/user.svg'

const NewUserView = (props) => {

    const emptyModelDefinition = {
        email:"",
        password:"",
        confirmPassword:'',
        firstName:"",
        lastName:"",      
    }
    const [openNewModelDialog, setOpenNewModelDialog] = useState(false);
    const [newModel, setNewModel] = useState({...emptyModelDefinition})

    function handleChange(e) {
        const { name, value } = e.target;
        setNewModel(inputs => ({ ...inputs, [name]: value }));
        console.log(newModel)
        props.setNewUserDef && props.setNewUserDef({...newModel,[name]: value})
    }

    function handleCheckedChange(e) {
        const { name, value, checked } = e.target;
        setNewModel(inputs => ({ ...inputs, [name]: checked }));
        
        props.setNewUserDef && props.setNewUserDef({...newModel,[name]: checked})
    }


    return (
        <div style={{background:'#EFEFEF', display:'flex', justifyContent:'center', flexDirection: 'row'}}>
                        
            <div style={{padding:3, maxWidth:600, minWidth:300, width:'100%'}}>
               
                <div style={{background:'#FFFFFF',display:'flex', justifyContent:'flex-start',padding:0, border:'1px solid #CCCCCC', borderRadius:3, overflow:'hidden', margin:5, maxWidth:600}}>
                    <div align="left" style={{display:'inline-block',align:'left', background:'#CCCCCC'}}>
                        <img src={models_icon} className="module-logo" alt="logo" style={{margin:8}} />
                    </div>
                    <div style={{display:'inline-block', width:'100%', margin:5, verticalAlign:'top',display:'flex', justifyContent:'flex-start',flexDirection: 'column', alignItems:'flex-start'}}>
                        <table>
                            <tr>
                                <td className="input-label" >Email :</td>
                                <td><input name="email" className="text-input" value={newModel.email} onChange={handleChange} type="text"/></td>
                            </tr>
                            <tr>
                                <td className="input-label">First Name :</td>
                                <td className="absorbing-column"><input name="firstName" className="text-input" value={newModel.firstName} onChange={handleChange} type="text"/></td>
                            </tr>
                            <tr>
                                <td className="input-label">Last Name :</td>
                                <td className="absorbing-column"><input name="lastName" className="text-input" value={newModel.lastName} onChange={handleChange}/></td>
                            </tr>
                            <tr>
                                <td className="input-label">Default Password :</td>
                                <td className="absorbing-column"><input name="password" className="text-input" value={newModel.password} onChange={handleChange}/></td>
                            </tr>
                            <tr>
                                <td className="input-label">Confirm Default Password :</td>
                                <td className="absorbing-column"><input name="confirmPassword" className="text-input" value={newModel.confirmPassword} onChange={handleChange}/></td>
                            </tr>
                        </table>
                        </div>
                </div>

                
            </div>
        </div>
    )
}

const mapStateToProps= (state) => {
  return {
    models: state.models
  }
}

export default withRouter(connect(mapStateToProps)(NewUserView));